import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_not_found.svg'


const _withScopeId = n => (_pushScopeId("data-v-67019921"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notfound_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "notfound_img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "notfound_title" }, "404 Not found", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "notfound_text" }, "お探しのページが見つかりませんでした", -1))
const _hoisted_5 = { class: "notfound_button" }

import BaseButton from '@/components/BaseButton.vue';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const router = useRouter();

const transitionTopPage = () => {
  router.push({ name: 'f00' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: transitionTopPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("ホームへ戻る")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})